import { jsx, Fragment } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';

function WhenValidGrandChildren({
  children,
  grandChildren = children.props.children
}) {
  return /* @__PURE__ */ jsx(Fragment, { children: isNil(grandChildren) ? null : children });
}

export { WhenValidGrandChildren as default };
//# sourceMappingURL=WhenValidGrandChildren.mjs.map
